import { getPhoneNumberE164 } from '@/general/helpers/getPhoneNumberE164';
import { getSha256Hash } from '@/general/helpers/getSha256Hash';
import { isEmpty } from '@/utils/isEmpty';

import { PushToDataLayerConfig, PushToDataLayerData, pushToDataLayer } from './pushToDataLayer';

export const pushToDataLayerWithEnhancedConversion = async (
  email: string,
  phone: string | undefined,
  data: PushToDataLayerData,
  config?: PushToDataLayerConfig,
) => {
  const promises = [getSha256Hash(email)];
  if (!isEmpty(phone)) {
    promises.push(getSha256Hash(getPhoneNumberE164(phone ?? '')));
  }
  const [sha256_email_address, sha256_phone_number] = await Promise.all(promises);

  const enhancedConversionData = {
    sha256_email_address,
    sha256_phone_number,
    ...data,
  };

  pushToDataLayer(enhancedConversionData, config);
};
